import{jsx as t}from"react/jsx-runtime";import e from"styled-components";import{calculateRem as i,withVDSManager as o}from"@vds-core/utilities";import{ColorTokens as n}from"@vds-tokens/color";import{TypographyTokens as r}from"@vds-tokens/typography";import{Fonts as l}from"@vds-core/typography";const a=function(t){return{fontSize:"mobile"===t?r.fontsize.title[16].value:r.fontsize.title[20].value,lineHeight:"mobile"===t?r.lineheight.title[20].value:r.lineheight.title[24].value,letterSpacing:"0",fontWeight:r.fontweight.bold.value,fontFamily:l.VerizonNHGeDS}},f={children:void 0,viewport:"desktop",padding:"standard"},p=e.th.withConfig({displayName:"StyledTH",componentId:"VDS__sc-1a973s3-0"})`
  ${function({$typographyConfig:t}){return`\n    font-size: ${t.fontSize};\n    line-height: ${t.lineHeight};\n    letter-spacing: ${t.letterSpacing};\n    font-family: ${t.fontFamily};\n    font-weight: ${t.fontWeight};\n  `}};
  color: ${n.elements.primary.onlight.value};
  text-align: left;
  vertical-align: bottom;
  > :nth-child(n) {
    &:not(:first-child) {
      margin-top: ${i(14)};
    }
  }
  &:active,
  &:focus,
  &:hover {
    outline: none;
  }
`,s=function(e){const{children:i,viewport:o}=e;return t(p,Object.assign({},e,{$typographyConfig:a(o),children:i}))};s.defaultProps=f;var h=o(s);export{h as default};
